'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("itRowPrecompiler", function ($window, $rootScope, itUtils) {
  return function (tableCtrl, renderer) {
    var rowManager = this,
      $scope = tableCtrl.getScope(),
      config,
      context,
      renderedRows,
      rowManagementIntervalId = null,
      rowPrecompilationQueue = [];
    var initialize = function initialize() {
      config = tableCtrl.getConfig();
      context = tableCtrl.getContext();
      renderedRows = renderer.getCompiledRows();
    };
    rowManager.start = function () {
      initialize();
      rowPrecompilationQueue = null;
      rowManagementIntervalId = $window.setInterval(rowManagementCycle, config.rowManagementCycleInterval);
    };
    rowManager.stop = function () {
      $window.clearInterval(rowManagementIntervalId);
      rowManagementIntervalId = null;
    };
    rowManager.reset = function () {
      rowManager.stop();
      rowManager.start();
    };
    var rowManagementCycle = function rowManagementCycle() {
      if (rowPrecompilationQueue == null) {
        rowPrecompilationQueue = computePrecompilationQueue();
      }

      // console.log("precompute list = ", rowPrecompilationQueue);

      if (rowPrecompilationQueue.length) {
        var count = 0;
        do {
          precompileNextRow();
        } while (rowPrecompilationQueue.length && ++count < config.rowPerManagementCycle);
      } else {
        var watcherCount = itUtils.countWatchers(config.countRootWatchers ? $rootScope : $scope);

        // console.log("cleanup : watcher count = ", watcherCount);

        if (watcherCount > config.maxWatchers) {
          removeNextUnusedRows();
        } else {
          rowManager.stop();
        }
      }
    };
    var computePrecompilationQueue = function computePrecompilationQueue() {
      var pagination = context.pagination;
      if (!pagination.filled) {
        return [];
      }
      var precompilationList = [];
      var pageCount = config.preloadedPageCount;
      var rowCount = pageCount * pagination.count;
      var nextIdx = pagination.last + 1;
      var i = 0;
      while (nextIdx < pagination.total && i < rowCount) {
        if (renderedRows[nextIdx] == null) {
          precompilationList.push(nextIdx);
        }
        nextIdx++;
        i++;
      }

      // TODO : also add previous pages

      return precompilationList;
    };
    var removeNextUnusedRows = function removeNextUnusedRows() {
      var pagination = context.pagination,
        pageCount = config.preloadedPageCount,
        rowCount = pageCount * pagination.count;
      var firstIdx = Math.max(pagination.first - rowCount, 0);
      var lastIdx = Math.min(pagination.last + rowCount, pagination.total - 1);

      // console.log("dont touch from " + firstIdx + " to " + lastIdx);

      var removalCount = 0;
      for (var i = 0; i < renderedRows.length; i++) {
        if (i >= firstIdx && i <= lastIdx) {
          continue;
        }
        if (renderedRows[i] != null) {
          renderer.deleteRow(i);
          removalCount++;
        }
        if (removalCount >= config.rowPerManagementCycle) {
          break;
        }
      }
    };
    var precompileNextRow = function precompileNextRow() {
      var nextId = rowPrecompilationQueue[0];
      renderer.createRow(nextId, true);
      rowPrecompilationQueue.shift();
    };
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/common/itRowPrecompiler.js
// module id = 2801
// module chunks = 13